module.exports = __webpack_public_path__ + "fontawesome-webfont-v=4.4.0.76a4f23c6be74fd309e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/font-awesome/fontawesome-webfont-v=4.4.0.svg
// module id = 376
// module chunks = 2